import { RESET } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{

  }, preserve )
}

export default function (state = initialState(), action) {
  
  switch ( action.type ) {

    case RESET:
      
      state = initialState()

      break
    
    default:
  
    }
    
    return state
}
